import React, { useContext, useEffect, useState } from "react";
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useStyles } from "./Navigation.styles";
import FooterButtons from "../FooterButtons.";
import FormLayoutActions from "../../layoutComponents/FormLayout/FormLayoutActions";
import GdprCookies from "../GdprCookies";
import { useWebViewContext } from "../WebViewProvider/webViewContext";
import { SectionIndicatorContext } from "../../shared/contexts/SectionIndicatorContext";
import { useNavigate } from "react-router-dom";

export enum NavigationType {
    EMAIL = "email",
    SMS = "sms",
}

const navigateTo = (to: string): string => {
    if (to === NavigationType.EMAIL) {
        return process.env.PUBLIC_URL + "/psw-email-reset";
    }
    if (to === NavigationType.SMS) {
        return process.env.PUBLIC_URL + "/psw-phone-reset";
    }
    return process.env.PUBLIC_URL + "/";
};

const Navigation = () => {
    const styles = useStyles();
    const { setSectionNumber } = useContext(SectionIndicatorContext);
    const navigate = useNavigate();

    useEffect(() => {
        setSectionNumber(0);
    }, []);

    const [selectedValue, setSelectedValue] = useState<string>(NavigationType.EMAIL);

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedValue(event.target.value);
    };

    const { isWebView } = useWebViewContext();

    function onSubmit(event?: any) {
        event.preventDefault();
        navigate(navigateTo(selectedValue));
    }

    return (
        <form style={{ display: "flex", flexDirection: "column", flexGrow: 1 }} onSubmit={onSubmit}>
            <div className={styles.pageWrapper}>
                <Box sx={{ height: { xs: "20px", md: "56px" } }}></Box>

                <Typography variant="h2" sx={{ marginBottom: { xs: "32px", md: "45px" } }}>
                    Zapomenuté heslo
                </Typography>

                <Typography className={styles.textMargin} variant="h4" sx={{ marginBottom: "8px" }}>
                    Vyberte způsob nastavení nového hesla
                </Typography>

                <RadioGroup
                    sx={{ backgroundColor: "#fff", padding: "2rem 1.6rem", borderRadius: "8px", gap: "1.6rem" }}
                    name="radio-buttons-group"
                    onChange={handleRadioChange}
                    value={selectedValue}
                >
                    <FormControlLabel value={NavigationType.EMAIL} control={<Radio />} label="Odkaz na e-mail" />
                    <FormControlLabel value={NavigationType.SMS} control={<Radio />} label="SMS kód" />
                </RadioGroup>

                {/*<Box sx={{*/}
                {/*    display: "flex",*/}
                {/*    flexDirection: "column",*/}
                {/*    justifyContent: "flex-start",*/}
                {/*    alignItems: "flex-end",*/}
                {/*    marginTop: "2rem",*/}
                {/*    marginBottom: "2rem",*/}
                {/*    gap: "2rem"*/}
                {/*}}>*/}
                {/*    /!*<Button className={styles.btnNewPass} endIcon={<ArrowForward/>} variant="outlined" type="button"*!/*/}
                {/*    /!*        href={navigateTo(selectedValue)}>Pokracovat</Button>*!/*/}
                {/*</Box>*/}

                <FormLayoutActions>
                    <FooterButtons navigateTo={navigateTo(selectedValue)} />
                </FormLayoutActions>

                {!isWebView && <GdprCookies />}
            </div>
        </form>
    );
};

export default Navigation;
